import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import posthog from 'posthog-js'
import App from './app/App'
import { router } from './app/router/routes'
import { initPostHog } from '@/lib/analytics'
import { consumeProviderHandoffFromLocation } from '@/lib/handoffBootstrap'

if (initPostHog()) {
  posthog.capture('$pageview')

  router.subscribe((state) => {
    if (state.navigation.state === 'idle') {
      posthog.capture('$pageview')
    }
  })
}

await consumeProviderHandoffFromLocation()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
